import { ERRORS } from 'api/subscription'

const id = window.document.currentScript?.dataset.communityEmbedId
const src = window.document.currentScript?.attributes['src'].value

function createProxy() {
  const channel = new MessageChannel()
  const { port1, port2 } = channel
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = src.replace(/sdk\.js$/, 'sdk.html')
  iframe.setAttribute('data-testid', 'sdk-iframe')
  document.body.appendChild(iframe)

  iframe.addEventListener('load', () => {
    iframe.contentWindow?.postMessage({ action: 'initChannel' }, '*', [port2])
  })

  window.Community = {
    createSubscription(phone: string) {
      if (window.Community.subscribed) {
        return Promise.reject(ERRORS.ALREADY_SUBSCRIBED)
      }

      return new Promise((resolve, reject) => {
        port1.onmessage = handleIframeMessage
        const message = { action: 'submit', payload: { id, phone } }
        port1.postMessage(message)

        function handleIframeMessage(event: MessageEvent) {
          switch (event.data.action) {
            case 'error':
              reject(event.data.error)
              break
            case 'success':
              resolve(event.data.phone)
              window.Community.subscribed = true
              break
            default:
              break
          }
        }
      })
    },
    subscribed: false,
  }
}

function load() {
  console.log('Loading Commmunity SDK')
  if (window.Community) {
    // Already loaded sdk
    return
  }

  if (id) {
    createProxy()
  } else {
    console.warn('Community Embed ID not found')
  }
}

if (document.readyState === 'complete' || 'Cypress' in window) {
  load()
} else {
  console.log('Document not ready, adding listener')
  document.onreadystatechange = function () {
    if (document.readyState === 'complete') {
      load()
    }
  }
}

export {}
